<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr
        :btitle="'ONT Catv Port'"
        style="min-height: 100%"
        :closeButton="false"
        :collapseStatus="'close'"
      >
        <!-- 按钮 -->
        <div class="form-inline" style="height: 35px">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>
        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAllCatvPort()"
                  id="idSelectAllCatvPort"
                />
                <label for="idSelectAllCatvPort"></label>
              </th>
              <th
                v-for="(value, key) in ontCatvPort.title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody style="height: 100%">
            <tr v-for="(row, index) in ontCatvPort.data" :key="row.port">
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'selectCatvPort' + index"
                  />
                  <label :for="'selectCatvPort' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.port }}</div>
              </td>
              <td>
                <div>{{ row.enable }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <!--配置弹窗-->
        <div v-if="isShowEditTable">
          <dialog-box
            :btitle="'Catv Port Config'"
            @close="isShowEditTable = false"
            style="height: 100%"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="portadmin">
                  Admin
                </label>
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="portadmin"
                    v-model="ontPortAdmin"
                  >
                    <option label="shutdown" value="0"></option>
                    <option label="no shutdown" value="1"></option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 25%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>
  </div>
</template>
<script>
import BlockCntr from "@/components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"

export default {
  name: "ontCatvPort",
  data() {
    return {
      isShowEditTable: false,
      isSelectAll: false,
      iBox: {},
      ontCatvPort: "",
      ontPortAdmin: "",
    }
  },
  props: ["ontIndex"],
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  created() {
    this.loadOntCatvPort()
  },
  methods: {
    loadOntCatvPort() {
      get("ontCatvPort?ontIndex=" + this.ontIndex)
        .then((res) => (this.ontCatvPort = res.data))
        .catch((err) => {})
    },
    clkEdit() {
      for (let i = 0; i < this.ontCatvPort.data.length; i++) {
        if (this.ontCatvPort.data[i].selected) {
          this.isShowEditTable = true
          return
        }
      }
    },
    changeSelectAllCatvPort() {
      for (let i = 0; i < this.ontCatvPort.data.length; i++) {
        if (this.isSelectAll) {
          this.ontCatvPort.data[i].selected = true
        } else {
          this.ontCatvPort.data[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.ontCatvPort.data.length; i++) {
        this.ontCatvPort.data[i].selected = false
      }
      this.isSelectAll = false
    },

    clkCancel() {
      this.isShowEditTable = false
    },

    clkApply() {
      var ontCatvPortCfg = {
        ontIndex: this.ontIndex,
        admin: Number(this.ontPortAdmin),
        portList: [],
      }

      for (let i = 0; i < this.ontCatvPort.data.length; i++) {
        if (this.ontCatvPort.data[i].selected) {
          ontCatvPortCfg.portList.push({
            port: Number(this.ontCatvPort.data[i].port),
          })
        }
      }
      post("ontCatvPortConfig", ontCatvPortCfg)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadontPortStatus()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })

      this.isShowEditTable = false
      this.selectNull()
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>>